import type {BaseComponentPart} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import type {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import type {SkeletonMode} from '@Components/ai-chat-window/lib/skeleton.types';

export interface EntityDraftSkeletonProps {
  mode: SkeletonMode;
}

export type EntityDraftSkeletonComponentPart = BaseComponentPart<StreamComponentType.ENTITY_DRAFT_SKELETON, EntityDraftSkeletonProps>;

export const SKELETON_DRAFT_TEXT_LINE_HEIGHT = 16;
export const SKELETON_DRAFT_META_WIDTH = 142;
export const SKELETON_DRAFT_STATUS_WIDTH = 72;
export const SKELETON_DRAFT_MEDIA_HEIGHT = 240;
